import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForumData } from './forumData';

const routes: Routes = [
  {
    path: 'forum',
    component: ForumData,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForumDataRoutingModule {}
